import util from '../util'

let controller = 'Operacoes'
export default Object.assign({}, util.GetCrud(controller, null), {
  PutDadosContabeis: function (id, dto) {
    return util.Axios.Put(controller + '/DadosContabeis', id, dto)
  }
})
